import Swiper from "swiper";
import { Navigation, Pagination, Keyboard } from "swiper/modules";

export default class SwiperGallery {

  public readonly swiper: Swiper;

  constructor(element: HTMLElement)
  {
    this.swiper = new Swiper(element, {

      keyboard: {
        enabled: true
      },
      lazyPreloadPrevNext: 3,
      modules: [Navigation, Pagination, Keyboard],
      loop: true,
      pagination: {
        el: '.swiper-pagination'
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 0,
      breakpoints: {
        '@0.8': {
          spaceBetween: 20,
        },
        '@1.1': {
          spaceBetween: 30,
        },
      },
    })
  }

  public destroy(): void
  {
    this.swiper.destroy();
  }
}
